(function () {
  'use strict';

  var STORAGE_KEY = 'mcm_delivery_location_v1';
  var ACTOR_KEY = 'mcm_delivery_actor_v1';
  var EVENT = 'mcm:delivery-location-changed';
  var PROXY = '/apps/mcm-delivery';
  var STATES = ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'ACT', 'NT'];
  var FALLBACK = { postcode: '2021', city: 'Paddington', province: 'NSW' };

  var store = {
    get: function (key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    },
    set: function (key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) { /* optional */ }
    },
    remove: function (key) {
      try { window.localStorage.removeItem(key); } catch (e) { /* optional */ }
    },
  };

  function read(value) {
    try { return JSON.parse(value || 'null'); } catch (e) { return null; }
  }

  function tidy(loc) {
    return {
      postcode: String((loc && loc.postcode) || '').trim(),
      city: String((loc && loc.city) || '').trim(),
      province: String((loc && loc.province) || '').trim().toUpperCase(),
    };
  }

  function valid(loc) {
    return !!loc && /^\d{4}$/.test(loc.postcode)
      && !!loc.city && loc.city.length <= 150
      && STATES.indexOf(loc.province) !== -1;
  }

  function titleCase(value) {
    return String(value || '').toLowerCase().replace(/\b[a-z]/g, function (ch) {
      return ch.toUpperCase();
    });
  }

  function placeLabel(loc) {
    if (!valid(loc)) return 'Set location';
    return titleCase(loc.city) + ' ' + loc.postcode;
  }

  function formatFrom(cents) {
    var dollars = cents / 100;
    if (Math.round(dollars) === dollars) return '$' + dollars;
    return dollars.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
  }

  function all(selector) {
    var live = Array.prototype.slice.call(document.querySelectorAll(selector));
    var nested = Array.prototype.slice.call(document.querySelectorAll('template')).reduce(function (found, tpl) {
      if (!tpl.content) return found;
      return found.concat(Array.prototype.slice.call(tpl.content.querySelectorAll(selector)));
    }, []);
    return live.concat(nested);
  }

  function init() {
    var root = document.querySelector('[data-mcm-delivery-bootstrap]');
    var dialog = document.querySelector('[data-mcm-delivery-dialog]');
    if (!root) return;

    var actor = root.getAttribute('data-customer-id') ? 'customer:' + root.getAttribute('data-customer-id') : 'guest';
    var lastActor = store.get(ACTOR_KEY);
    var prior = read(store.get(STORAGE_KEY));
    if (lastActor !== actor) {
      if (lastActor === 'guest' && actor !== 'guest' && prior && prior.actor === 'guest'
        && prior.source === 'manual' && valid(prior.location)) {
        store.set(STORAGE_KEY, JSON.stringify({ actor: actor, location: prior.location, source: 'manual' }));
      } else {
        store.remove(STORAGE_KEY);
      }
      store.set(ACTOR_KEY, actor);
    }

    var defaults = tidy({
      postcode: root.getAttribute('data-default-postcode'),
      city: root.getAttribute('data-default-city'),
      province: root.getAttribute('data-default-province'),
    });
    var accountLocation = root.getAttribute('data-default-country') === 'AU' && valid(defaults) ? defaults : null;
    var savedAddresses = all('[data-mcm-delivery-bootstrap] [data-mcm-saved-address]')
      .filter(function (node) { return node.getAttribute('data-country') === 'AU'; })
      .map(function (node) {
        return tidy({
          postcode: node.getAttribute('data-postcode'),
          city: node.getAttribute('data-city'),
          province: node.getAttribute('data-province'),
        });
      })
      .filter(valid)
      .filter(function (value, index, values) {
        return values.findIndex(function (other) {
          return other.postcode === value.postcode && other.city === value.city && other.province === value.province;
        }) === index;
      });

    var saved = read(store.get(STORAGE_KEY));
    var location = saved && saved.actor === actor && valid(saved.location) ? saved.location : (accountLocation || FALLBACK);
    var productToken = 0;
    var cartToken = 0;
    var lastCartPrice = '—';
    var quoteTimer = 0;
    var paintingDom = false;

    function current() {
      if (window.MCMDeliveryLocation && window.MCMDeliveryLocation !== api) {
        return window.MCMDeliveryLocation.get() || location;
      }
      return location;
    }

    function persist(next) {
      location = next;
      store.set(STORAGE_KEY, JSON.stringify({ actor: actor, location: next, source: 'manual' }));
    }

    var api = {
      get: function () { return location ? Object.assign({}, location) : null; },
      set: function (value) {
        var next = tidy(value);
        if (!valid(next)) return false;
        persist(next);
        notify();
        return true;
      },
      open: function () { openDialog(); },
      refresh: function () { notify(); },
    };

    if (!window.MCMDeliveryLocation) window.MCMDeliveryLocation = api;

    function paintPlaces() {
      var loc = current();
      var label = placeLabel(loc);
      paintingDom = true;
      all('[data-mcm-delivery-place]').forEach(function (el) {
        setText(el, label);
      });
      paintingDom = false;
    }

    function productItems(block) {
      var section = block.closest('section, product-info, .shopify-section, .product-details, .product-information') || document;
      var selected = section.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = String((selected && selected.value) || block.getAttribute('data-variant-id') || '');
      if (!/^\d+$/.test(id)) return [];
      return [{ id: id, quantity: 1, requiresShipping: block.getAttribute('data-requires-shipping') !== 'false' }];
    }

    function paintFrom(block, text) {
      var el = block.querySelector('[data-mcm-delivery-from]');
      if (el) setText(el, text || '');
    }

    function quoteProduct(block) {
      var loc = current();
      var items = productItems(block);
      var token = ++productToken;
      if (!valid(loc) || !items.length || items[0].requiresShipping === false) {
        paintFrom(block, '');
        return;
      }
      paintFrom(block, '');
      fetch(PROXY, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ location: loc, items: items }),
      }).then(function (res) {
        if (!res.ok) throw new Error('unavailable');
        return res.json();
      }).then(function (result) {
        if (token !== productToken || !block.isConnected) return;
        var rates = (result.rates || []).filter(function (rate) {
          return rate && typeof rate.cents === 'number' && isFinite(rate.cents) && rate.cents >= 0
            && rate.code !== 'MCM_QUOTE_REQUIRED'
            && String(rate.code || '').indexOf('MCM_COLLECTION_') !== 0;
        });
        if (!rates.length) {
          paintFrom(block, '');
          return;
        }
        var lowest = Math.min.apply(null, rates.map(function (rate) { return rate.cents; }));
        paintFrom(block, ' from ' + formatFrom(lowest));
      }).catch(function () {
        if (token === productToken) paintFrom(block, '');
      });
    }

    function normalizeLead(raw) {
      var text = String(raw || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      if (!text) return '';
      if (text.indexOf('_') !== -1) text = text.split('_').pop().trim();
      text = text.replace(/^available\s+/i, '').replace(/^by\s+/i, '').trim();
      var key = text.toLowerCase();
      if (!text || key === 'in stock' || key === 'available now' || key === 'n/a' || key === 'na' || key === 'tbc' || key === 'tbd') return '';
      return text;
    }

    var MONTH_INDEX = {
      jan: 1, january: 1, feb: 2, february: 2, mar: 3, march: 3, apr: 4, april: 4,
      may: 5, jun: 6, june: 6, jul: 7, july: 7, aug: 8, august: 8,
      sep: 9, sept: 9, september: 9, oct: 10, october: 10, nov: 11, november: 11, dec: 12, december: 12,
    };

    /** Higher = later / longer lead. In-stock / empty → 0. */
    function leadRank(raw) {
      var text = normalizeLead(raw);
      if (!text) return 0;
      var key = text.toLowerCase();

      var weeks = key.match(/(\d{1,3})\s*[-–—]?\s*(\d{1,3})?\s*weeks?/);
      if (weeks) {
        return 500000000000 + Number(weeks[2] || weeks[1]) * 7 * 86400000;
      }

      var dated = key.match(/(\d{1,2})(?:st|nd|rd|th)?\s+(jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)(?:\s+(\d{4}))?/);
      if (dated) {
        var day = Number(dated[1]);
        var monthDated = MONTH_INDEX[dated[2]] || 1;
        var yearDated = dated[3] ? Number(dated[3]) : new Date().getFullYear();
        var datedAt = new Date(yearDated, monthDated - 1, day).getTime();
        if (!dated[3] && datedAt < Date.now() - 86400000) {
          datedAt = new Date(yearDated + 1, monthDated - 1, day).getTime();
        }
        return datedAt;
      }

      var monthMatch = key.match(/\b(early|mid|middle|late)?\s*(jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\b/);
      if (monthMatch) {
        var period = monthMatch[1] || '';
        var dayOfMonth = period.indexOf('early') === 0 ? 5 : period.indexOf('late') === 0 ? 25 : 15;
        var month = MONTH_INDEX[monthMatch[2]] || 1;
        var year = new Date().getFullYear();
        var at = new Date(year, month - 1, dayOfMonth).getTime();
        if (at < Date.now() - 86400000) at = new Date(year + 1, month - 1, dayOfMonth).getTime();
        return at;
      }

      return 1;
    }

    /** Longest / latest lead among cart items (skips in-stock). */
    function longestLead(rawLeads) {
      var best = '';
      var bestRank = 0;
      (rawLeads || []).forEach(function (raw) {
        var text = normalizeLead(raw);
        if (!text) return;
        var rank = leadRank(text);
        if (rank >= bestRank) {
          bestRank = rank;
          best = text;
        }
      });
      return best;
    }

    function leadSuffix(rawLeads) {
      var later = longestLead(rawLeads);
      return later ? ' by ' + later : '';
    }

    function itemLead(item) {
      var props = item && item.properties ? item.properties : {};
      return props['Lead time'] || props.lead_time || props.Lead_time || '';
    }

    function seededLeads() {
      var leads = [];
      all('[data-mcm-cart-leads]').forEach(function (node) {
        try {
          var parsed = JSON.parse(node.textContent || '[]');
          if (Array.isArray(parsed)) leads = leads.concat(parsed);
        } catch (e) { /* keep any leads already found */ }
      });
      return leads;
    }

    function setText(el, value) {
      var next = value == null ? '' : String(value);
      if (el.textContent === next) return;
      el.textContent = next;
    }

    function paintPrice(priceText) {
      lastCartPrice = priceText || '—';
      paintingDom = true;
      all('[data-mcm-cart-price], [data-shipping-price]').forEach(function (el) {
        setText(el, lastCartPrice);
      });
      paintingDom = false;
    }

    function scheduleQuote() {
      paintPrice(lastCartPrice);
      window.clearTimeout(quoteTimer);
      quoteTimer = window.setTimeout(quoteCart, 150);
    }

    function paintLead(leadText) {
      var text = String(leadText || '').replace(/^by\s+/i, '').trim();
      if (!text || /^in stock$/i.test(text)) text = longestLead(seededLeads());
      var display = text || 'In Stock';
      paintingDom = true;
      all('[data-mcm-cart-lead]').forEach(function (el) {
        setText(el, text ? ' by ' + text : '');
      });
      all('[data-mcm-cart-lead-value]').forEach(function (el) {
        setText(el, display);
      });
      all('[data-mcm-cart-lead-row]').forEach(function (el) {
        el.hidden = false;
      });
      paintingDom = false;
    }

    function quoteCart() {
      var loc = current();
      var token = ++cartToken;
      paintLead(longestLead(seededLeads()));
      if (!valid(loc)) {
        paintPrice('—');
        return;
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
        if (!res.ok) throw new Error('cart unavailable');
        return res.json();
      }).then(function (cart) {
        if (token !== cartToken) return;
        var physical = (cart.items || []).filter(function (item) { return item.requires_shipping; });
        if (!physical.length || physical.length > 20) {
          paintPrice('—');
          return;
        }
        var cartLeads = physical.map(itemLead).concat(seededLeads());
        paintLead(longestLead(cartLeads));
        var items = physical.map(function (item) {
          return {
            id: String(item.variant_id || item.id),
            quantity: item.quantity,
            requiresShipping: true,
          };
        });
        return fetch(PROXY, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ location: loc, items: items }),
        }).then(function (res) {
          if (!res.ok) throw new Error('unavailable');
          return res.json();
        }).then(function (result) {
          if (token !== cartToken) return;
          var rates = (result.rates || []).filter(function (rate) {
            return rate && typeof rate.cents === 'number' && isFinite(rate.cents) && rate.cents >= 0
              && rate.code !== 'MCM_QUOTE_REQUIRED'
              && String(rate.code || '').indexOf('MCM_COLLECTION_') !== 0;
          });
          var apiLeads = (result.leadTimes || []).map(function (entry) { return entry && entry.text; });
          paintLead(longestLead(cartLeads) || longestLead(apiLeads));
          if (!rates.length) {
            paintPrice('—');
            return;
          }
          var lowest = Math.min.apply(null, rates.map(function (rate) { return rate.cents; }));
          paintPrice(formatFrom(lowest));
        });
      }).catch(function () {
        if (token === cartToken) paintPrice('—');
      });
    }

    function refreshEstimates() {
      paintPlaces();
      all('[data-mcm-product-shipping]').forEach(quoteProduct);
      scheduleQuote();
    }

    function bindSavedAddresses() {
      if (!dialog || savedAddresses.length < 2 || dialog.querySelector('[data-mcm-saved-select]')) return;
      var fields = dialog.querySelector('.mcm-delivery-dialog__fields');
      if (!fields) return;
      var label = document.createElement('label');
      label.className = 'mcm-delivery-dialog__field mcm-delivery-dialog__saved';
      label.textContent = 'Or choose a saved address';
      var select = document.createElement('select');
      select.setAttribute('data-mcm-saved-select', '');
      var prompt = document.createElement('option');
      prompt.value = '';
      prompt.textContent = 'Select an address';
      select.appendChild(prompt);
      savedAddresses.forEach(function (address, index) {
        var option = document.createElement('option');
        option.value = String(index);
        option.textContent = titleCase(address.city) + ', ' + address.province + ' ' + address.postcode;
        select.appendChild(option);
      });
      select.addEventListener('change', function () {
        var selected = savedAddresses[Number(select.value)];
        if (!selected || select.value === '') return;
        var form = dialog.querySelector('form');
        form.elements.postcode.value = selected.postcode;
        form.elements.province.value = selected.province;
        fillSuburbSelect([selected], selected);
        var postcodeField = form.elements.postcode;
        if (postcodeField) postcodeField.dispatchEvent(new Event('input'));
      });
      label.appendChild(select);
      fields.insertBefore(label, fields.firstChild);
    }

    function setError(message) {
      var alertEl = dialog.querySelector('[role="alert"]');
      if (alertEl) alertEl.textContent = message || '';
    }

    function selectedPlace() {
      var form = dialog.querySelector('form');
      var cityOpt = form && form.elements.city && form.elements.city.selectedOptions[0];
      return tidy({
        postcode: form ? form.elements.postcode.value : '',
        city: (cityOpt && cityOpt.getAttribute('data-city')) || '',
        province: (cityOpt && cityOpt.getAttribute('data-province')) || (form && form.elements.province.value) || '',
      });
    }

    function syncSave() {
      var save = dialog.querySelector('[data-mcm-save]');
      if (save) save.disabled = !valid(selectedPlace());
    }

    function resetPlaceFields(suburbPrompt) {
      var form = dialog.querySelector('form');
      if (!form) return;
      form.elements.province.value = '';
      fillSuburbSelect([], null, suburbPrompt || 'Enter a postcode');
      syncSave();
    }

    function fillSuburbSelect(options, selected, emptyPrompt) {
      var form = dialog.querySelector('form');
      var cityField = form && form.elements.city;
      if (!cityField) return;
      cityField.innerHTML = '';
      var prompt = document.createElement('option');
      prompt.value = '';
      if (!options.length) {
        prompt.textContent = emptyPrompt || 'No suburbs for this postcode';
        cityField.appendChild(prompt);
        cityField.value = '';
        cityField.disabled = true;
        return;
      }
      prompt.textContent = 'Choose suburb';
      if (options.length > 1) cityField.appendChild(prompt);
      options.forEach(function (item, index) {
        var opt = document.createElement('option');
        opt.value = String(index);
        opt.textContent = titleCase(item.city);
        opt.setAttribute('data-city', item.city);
        opt.setAttribute('data-province', item.province);
        cityField.appendChild(opt);
      });
      cityField.disabled = false;
      var pick = -1;
      if (selected) {
        pick = options.findIndex(function (item) {
          return item.city.toLowerCase() === selected.city.toLowerCase()
            && item.province === selected.province;
        });
      }
      if (options.length === 1) pick = 0;
      if (pick >= 0) {
        cityField.value = String(pick);
        form.elements.province.value = options[pick].province;
      } else {
        cityField.value = '';
      }
    }

    function bindSuburbLookup() {
      if (!dialog || dialog.getAttribute('data-suburb-bound')) return;
      dialog.setAttribute('data-suburb-bound', 'true');
      var form = dialog.querySelector('form');
      var postcodeField = form.elements.postcode;
      var cityField = form.elements.city;
      var lookupRevision = 0;
      cityField.addEventListener('change', function () {
        var opt = cityField.selectedOptions[0];
        if (!opt || !opt.value) {
          form.elements.province.value = '';
          setError('Choose a suburb for this postcode.');
          syncSave();
          return;
        }
        form.elements.province.value = opt.getAttribute('data-province') || '';
        setError('');
        syncSave();
      });
      function lookup() {
        var postcode = postcodeField.value.trim();
        var version = ++lookupRevision;
        setError('');
        resetPlaceFields(postcode ? 'Checking postcode…' : 'Enter a postcode');
        if (!postcode) return;
        if (!/^[0-9]{4}$/.test(postcode)) {
          if (postcode.length === 4) setError('Enter a valid four-digit Australian postcode.');
          return;
        }
        fetch(PROXY, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lookupPostcode: postcode }),
        }).then(function (res) {
          if (!res.ok) return null;
          return res.json();
        }).then(function (data) {
          if (version !== lookupRevision || postcodeField.value.trim() !== postcode) return;
          var options = ((data && data.locations) || []).filter(function (item) {
            return item.postcode === postcode && valid(tidy(item));
          });
          if (!options.length) {
            setError('This postcode isn’t available for delivery.');
            resetPlaceFields('No suburbs for this postcode');
            return;
          }
          setError('');
          fillSuburbSelect(options, current());
          syncSave();
        }).catch(function () {
          if (version !== lookupRevision) return;
          setError('We couldn’t check this postcode. Try again.');
          resetPlaceFields('No suburbs for this postcode');
        });
      }
      postcodeField.addEventListener('input', lookup);
      postcodeField.addEventListener('change', lookup);
      postcodeField.addEventListener('blur', lookup);
    }

    function openThemeDialog() {
      if (!dialog) return;
      bindSavedAddresses();
      bindSuburbLookup();
      var loc = current();
      var form = dialog.querySelector('form');
      setError('');
      form.elements.postcode.value = (loc && loc.postcode) || '';
      form.elements.province.value = (loc && loc.province) || '';
      if (valid(loc)) fillSuburbSelect([loc], loc);
      else fillSuburbSelect([], null, 'Enter a postcode');
      syncSave();
      if (!dialog.open) dialog.showModal();
      form.elements.postcode.focus();
      if (valid(loc)) form.elements.postcode.dispatchEvent(new Event('input'));
    }

    function openDialog() {
      openThemeDialog();
    }

    function notify() {
      document.dispatchEvent(new CustomEvent(EVENT, { detail: { location: api.get() } }));
      refreshEstimates();
    }

    if (dialog) {
      var closeBtn = dialog.querySelector('[data-mcm-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
      var form = dialog.querySelector('form');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var cityOpt = form.elements.city.selectedOptions[0];
          var next = tidy({
            postcode: form.elements.postcode.value,
            city: (cityOpt && (cityOpt.getAttribute('data-city') || cityOpt.textContent)) || '',
            province: (cityOpt && cityOpt.getAttribute('data-province')) || form.elements.province.value,
          });
          if (!api.set(next)) {
            var alertEl = dialog.querySelector('[role="alert"]');
            if (alertEl) alertEl.textContent = 'Enter a four-digit Australian postcode, suburb and state.';
            return;
          }
          dialog.close();
        });
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-mcm-delivery-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openDialog();
    });

    document.addEventListener(EVENT, function (event) {
      var next = event.detail && event.detail.location;
      if (valid(next)) location = tidy(next);
      refreshEstimates();
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('form[action*="/cart/add"] [name="id"]')) {
        window.setTimeout(refreshEstimates, 100);
      }
    });
    ['variant:change', 'product:variant-change', 'cart:change', 'cart:updated', 'cart:refresh', 'cart-drawer:open', 'drawer:show', 'drawer:before-show', 'shopify:section:load'].forEach(function (name) {
      document.addEventListener(name, function () {
        window.setTimeout(refreshEstimates, 150);
      });
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== STORAGE_KEY) return;
      var other = read(event.newValue);
      location = other && other.actor === actor && valid(other.location) ? other.location : (accountLocation || FALLBACK);
      refreshEstimates();
    });

    // Re-paint after cart-drawer morphs. Ignore our own text updates — setting
    // textContent replaces #text nodes and would otherwise retrigger this
    // observer every frame, clearing scheduleQuote before quoteCart can run.
    var drawerPaintQueued = false;
    var drawerRoot = document.querySelector('cart-drawer, .cart-drawer, .summary__subtotal--floating');
    if (drawerRoot && window.MutationObserver) {
      new MutationObserver(function () {
        if (paintingDom || drawerPaintQueued) return;
        drawerPaintQueued = true;
        window.requestAnimationFrame(function () {
          drawerPaintQueued = false;
          if (paintingDom) return;
          paintPlaces();
          paintLead(longestLead(seededLeads()));
          scheduleQuote();
        });
      }).observe(drawerRoot, { childList: true, subtree: true });
    }

    refreshEstimates();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
